import React, { useEffect, useState } from "react"
import BackgroundAuthentication from "../../components/Lystface/Common/BackgroundAuthentication"
import SignupForm from "../../components/Lystface/Signup/SignupForm"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { appConstants } from "../../constants/app_constants"
import Toaster from "../../components/Lystface/Common/Toaster"
import toast_messages from "../../constants/toast_messages"
import { CustomToast, ToastContainer } from "../../components/Lystface/Common/CustomToast"
import { resetRegisterResponseMsg } from "../../store/actions"
import { useNavigate } from "react-router-dom"
import { Helmet } from "react-helmet"

const Singup = () => {
  document.title = `Signup | ${appConstants.cName}`
  const [error, setIsError] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const RegisterUserState = state => state.Account
  const RegisterUserProperties = createSelector(
    RegisterUserState,
    RegisterUser => ({
      registrationErrorMessage: RegisterUser.registrationErrorMessage,
      registrationError: RegisterUser.registrationError,
    })
  )
  const {
    registrationErrorMessage,
    registrationError,
  } = useSelector(RegisterUserProperties)

  useEffect(() => {
    if ((error ? toast_messages.ErrorCountry : registrationErrorMessage) !== null) {
      CustomToast({
        message: error ? toast_messages.ErrorCountry : registrationErrorMessage,
        status: registrationError || error ? 'failure' : 'success',
        closeToast: () => {
          console.log('Toast closed');
        },
      })
      if (!registrationError) {
        navigate('/signup/success')
      }
      dispatch(resetRegisterResponseMsg())
    }
  }, [registrationError, registrationErrorMessage, error, toast_messages.ErrorCountry])
  return (
    <>
      <Helmet>
        <link rel="icon" href="https://img-assets.lystface.com/web/logo/logoSm.svg" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta name="description"
          content="Create your account with Lystface to start using our face recognition API. Begin your journey with cutting-edge AI-powered facial recognition technology today." />
        <meta property="og:image" content="https://img-assets.lystface.com/web/logo/logoSm.svg" />
        <link rel="apple-touch-icon" href="https://img-assets.lystface.com/web/logo/logoSm.svg" />
        <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
        <title>Sign Up for {appConstants.cName} | Get Started with Face Recognition API</title>

      </Helmet>
      <BackgroundAuthentication Image={true} form={<SignupForm setIsError={setIsError} />} />
    </>
  )
}

export default Singup
